export default __webpack_public_path__ + "static/media/livecoding.efd8e372.jpeg";